<div>
  <div class='floating-bar'>
    <div class='row'>
      <div class='col-3'>
        <div class='p-3' style='cursor: default'>
            <app-control-adresse></app-control-adresse>
        </div>
      </div>
      <div class='col-8' *ngIf='!bNouvelleSimulation'></div>
      <div class='col-1' *ngIf='!bNouvelleSimulation'>
        <div [hidden]='false' class='nouvelle-simulation' style='text-align: right'>
          <a (click)='onButtonClick()' title='Nouvelle simulation'>
            <span class="bi bi-file-earmark-plus-fill"></span>
          </a>
          <img
          src="../../../../assets/images/img/saved-simulation.png"
          class="saved-simulation"
          alt="Simulation enregistrées"
           title="Simulation enregistrées"
          (click)='onButtonClickSimuEnreg()'
           />
        </div>
        <div  [hidden]='true' class='nouvelle-simulation' style='text-align: right'>
          <button class='btn btn-submit btn-primary' (click)="onButtonClick()">Nouvelle simulation</button>
        </div>
      </div>
      <app-form-parent class='col-9' style='overflow: hidden; margin-top: 10px;' [bNouvelleSimulation]=bNouvelleSimulation [showSimulationEnreg]=showSimulationEnreg *ngIf='bNouvelleSimulation'> </app-form-parent>
    </div>
  </div>
  <div #tooltip class='measure-tooltip'></div>
  <app-calepinage-recap></app-calepinage-recap>
  <app-map id="mapContainer" class='d-flex flex-column align-items-center' [map]='geoMap'></app-map>
</div>
